import { Link } from 'react-router';
import { type MaintenanceTemplateScope } from '@gb-ticket/shared-types';

import {
  maintenanceInstallationPath,
  maintenanceProjectPath,
} from '@/products/maintenance/maintenance-paths';

export function MaintenanceTemplateScopeRow({ scope }: { scope: MaintenanceTemplateScope }) {
  if (scope.installationId) {
    const label = scope.installation
      ? `${scope.installation.installationNumber} – ${scope.installation.name}`
      : 'Anlage';
    const location = scope.installation?.location;
    return (
      <div className="text-sm">
        <Link
          className="text-primary hover:underline"
          to={maintenanceInstallationPath(scope.installationId)}
        >
          Anlage: {label}
        </Link>
        {location ? <p className="text-muted-foreground">{location}</p> : null}
      </div>
    );
  }

  if (scope.projectId) {
    const label = scope.project?.name ?? 'Projekt';
    return (
      <Link
        className="text-sm text-primary hover:underline"
        to={maintenanceProjectPath(scope.projectId)}
      >
        Projekt: {label}
      </Link>
    );
  }

  return null;
}
